const ROUND = 'fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"';

function rays(radius: number, length: number, angles: readonly number[]): string {
  return angles
    .map((degrees) => {
      const angle = (degrees * Math.PI) / 180;
      const point = (r: number) =>
        `${(12 + r * Math.cos(angle)).toFixed(2)} ${(12 + r * Math.sin(angle)).toFixed(2)}`;
      return `M${point(radius)}L${point(radius + length)}`;
    })
    .join('');
}

export const CIRCADIEN_MARK =
  '<path d="M12 5.6a6.4 6.4 0 0 1 0 12.8z" fill="currentColor"/>' +
  '<circle cx="12" cy="12" r="6.4" fill="none" stroke="currentColor" stroke-width="1.8"/>' +
  '<path d="M10.2 8.9A3.32 3.32 0 1 0 10.2 15.1A3.6 3.6 0 0 1 10.2 8.9z" fill="currentColor"/>' +
  `<path d="${rays(8, 2.6, [-64, -22, 22, 64])}" ${ROUND} stroke-width="1.8"/>`;

export const ECLIPSE_ICON =
  `<path d="${rays(8.4, 2.8, [0, 45, 90, 135, 180, 225, 270, 315])}" ${ROUND} stroke-width="1.8"/>` +
  '<circle cx="12" cy="12" r="6.2" fill="none" stroke="currentColor" stroke-width="1.8"/>' +
  '<circle cx="13.4" cy="10.8" r="4.6" fill="currentColor"/>';
